export interface INavigationRoute {
    name: string
    displayName: string
    meta: { icon: string }
    children?: INavigationRoute[]
}

export default {
    root: {
        name: '/',
        displayName: 'navigationRoutes.home',
    },
    routes: [
        {
            name: 'dashboard',
            displayName: 'menu.dashboard',
            meta: {
                icon: 'vuestic-iconset-dashboard',
            },
        },
        {
            name: 'orders',
            displayName: 'menu.orders',
            meta: {
                icon: 'group',
            },
        },
        {
            name: 'guides',
            displayName: 'menu.guides',
            meta: {
                icon: 'girl',
            },
        },
        {
            name: 'therapists',
            displayName: 'menu.therapists',
            meta: {
                icon: 'healing',
            },
        },
        {
            name: 'teachers',
            displayName: 'menu.teachers',
            meta: {
                icon: 'girl',
            },
        },
        {
            name: 'promoters',
            displayName: 'menu.promoters',
            meta: {
                icon: 'handshake',
            },
        },
        {
            name: 'coupons',
            displayName: 'menu.coupons',
            meta: {
                icon: 'confirmation_number',
            },
        },
        {
            name: 'commission-records',
            displayName: 'menu.commission-records',
            meta: {
                icon: 'receipt_long',
            },
        },
        {
            name: 'commission-settlement-records',
            displayName: 'menu.commission-settlement-records',
            meta: {
                icon: 'payments',
            },
        },
        {
            name: 'affiliate-me',
            displayName: 'menu.affiliate-me',
            meta: {
                icon: 'analytics',
            },
            children: [
                {
                    name: 'affiliate-me-dashboard',
                    displayName: 'menu.affiliate-me-dashboard',
                    meta: {
                        icon: '',
                    },
                },
                {
                    name: 'affiliate-me-promo-codes',
                    displayName: 'menu.affiliate-me-promo-codes',
                    meta: {
                        icon: '',
                    },
                },
                {
                    name: 'affiliate-me-payout-history',
                    displayName: 'menu.affiliate-me-payout-history',
                    meta: {
                        icon: '',
                    },
                },
            ],
        },
        {
            name: 'ops-users',
            displayName: 'menu.ops-users',
            meta: {
                icon: 'manage_accounts',
            },
        },
        // {
        //     name: 'users',
        //     displayName: 'menu.users',
        //     meta: {
        //         icon: 'group',
        //     },
        // },
        // {
        //     name: 'projects',
        //     displayName: 'menu.projects',
        //     meta: {
        //         icon: 'folder_shared',
        //     },
        // },
        // {
        //     name: 'payments',
        //     displayName: 'menu.payments',
        //     meta: {
        //         icon: 'credit_card',
        //     },
        //     children: [
        //         {
        //             name: 'payment-methods',
        //             displayName: 'menu.payment-methods',
        //         },
        //         {
        //             name: 'pricing-plans',
        //             displayName: 'menu.pricing-plans',
        //         },
        //         {
        //             name: 'billing',
        //             displayName: 'menu.billing',
        //         },
        //     ],
        // },
        {
            name: 'auth',
            displayName: 'menu.auth',
            meta: {
                icon: 'login',
            },
            children: [
                {
                    name: 'login',
                    displayName: 'menu.login',
                },
                // {
                //     name: 'signup',
                //     displayName: 'menu.signup',
                // },
                // {
                //     name: 'recover-password',
                //     displayName: 'menu.recover-password',
                // },
            ],
        },

        // {
        //     name: 'faq',
        //     displayName: 'menu.faq',
        //     meta: {
        //         icon: 'quiz',
        //     },
        // },
        // {
        //     name: '404',
        //     displayName: 'menu.404',
        //     meta: {
        //         icon: 'vuestic-iconset-files',
        //     },
        // },
        // {
        //     name: 'preferences',
        //     displayName: 'menu.preferences',
        //     meta: {
        //         icon: 'manage_accounts',
        //     },
        // },
        // {
        //     name: 'settings',
        //     displayName: 'menu.settings',
        //     meta: {
        //         icon: 'settings',
        //     },
        // },
    ] as INavigationRoute[],
}
